import { ROLES } from "../store/constant";

export const mapUserRole = (level, isObject = false) => {
  const role = ROLES.find((a) => a.level === parseInt(level));
  return isObject ? role : role?.name;
};
